import { render, staticRenderFns } from "./App.vue?vue&type=template&id=023e940d&"
import script from "XC/components/app.component?vue&type=script&lang=js&"
export * from "XC/components/app.component?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports